import React from 'react';
import {NodeProps, useReactFlow} from 'reactflow';

import {PlaceholderNodeData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import {BenchlingNodeV2} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNode';

import createHeaderPropsForNode from './createHeaderPropsForNode';

/**
 * A placeholder node for when we are in the process of creating a new node in the flowchart.
 * This will be replaced with the actual node when the user finishes editing in the sidepanel for this placeholder node.
 */
export default function PlaceholderNodeRenderer(props: NodeProps<PlaceholderNodeData>): JSX.Element {
  const {data, xPos, yPos, id} = props;
  const reactFlowInstance = useReactFlow();
  const {isDisabled, status, onNodeHeaderClick} = data;

  const finalHeaderProps = createHeaderPropsForNode(
    {
      ...data,
      position: {x: xPos, y: yPos},
    },
    reactFlowInstance,
    true,
    false // do not allow connecting to this node until it is a real node, we can't handle that today
  );

  const handleHeaderClick = (): void => {
    onNodeHeaderClick?.(id);
  };

  return (
    <div onClick={handleHeaderClick} style={{cursor: onNodeHeaderClick != null ? 'pointer' : 'default'}}>
      <BenchlingNodeV2.Standard.Node
        isSelected={props.selected}
        isDisabled={isDisabled}
        status={status}
        headerProps={finalHeaderProps}
      />
    </div>
  );
}
